module.exports = __webpack_public_path__ + "static/powered-by-mindme-9b1c6b38437d9d916afe53594c262509.svg";